module.exports = __webpack_public_path__ + "img/footer_bg.9f1e5390.png";